import { ValidationRule } from './validate-fields'

export const hasError = (
  fieldErrors: Record<string, ValidationRule> | null | undefined,
  fieldPath: string,
): boolean => {
  if (!fieldErrors) return false
  return Object.prototype.hasOwnProperty.call(fieldErrors, fieldPath)
}

export const getInputStatus = (
  fieldErrors: Record<string, ValidationRule> | null | undefined,
  fieldPath: string,
): 'error' | 'success' | null | undefined => {
  if (!fieldErrors) return null
  return fieldErrors[fieldPath] ? 'error' : null
}

export const getSelectStatus = (
  fieldErrors: Record<string, ValidationRule> | null | undefined,
  fieldPath: string,
): 'error' | 'warning' | undefined => {
  if (!fieldErrors) return undefined
  return fieldErrors[fieldPath] ? 'error' : undefined
}

export const getFieldError = (
  fieldErrors: Record<string, ValidationRule> | null | undefined,
  fieldPath: string,
): React.ReactNode => {
  if (!fieldErrors) return ''

  const errorText = fieldErrors[fieldPath]?.textError || ''

  if (!errorText) return ''

  return <div style={{ whiteSpace: 'pre-line' }}>{errorText}</div>
}
